import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Audiences from "@/components/Audiences";
import RequestViewing from "@/components/RequestViewing";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import FAQ, { FAQ_KEYS } from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { useEffect } from "react";
import { BRAND } from "@/lib/brand";
import { useT } from "@/lib/i18n";

export default function Landing() {
  const { t, lang } = useT();

  useEffect(() => {
    // Inject JSON-LD (FAQPage + RealEstateAgent) — refreshes when language changes
    const faqLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_KEYS.map(([qk, ak]) => ({
        "@type": "Question",
        name: t(qk),
        acceptedAnswer: { "@type": "Answer", text: t(ak) },
      })),
    };
    const bizLd = {
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: BRAND.name,
      image: BRAND.logoUrl,
      telephone: BRAND.phoneRaw,
      areaServed: "Warsaw, Poland",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Warsaw",
        addressCountry: "PL",
      },
      knowsLanguage: ["tr", "en", "az", "pl"],
      description:
        "Helping newcomers find flats, rooms and houses in Warsaw and guiding them through PESEL, rental contracts and residency paperwork.",
    };
    const make = (id, data) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    };
    make("ld-faq", faqLd);
    make("ld-biz", bizLd);
    document.title = t("meta.title");
  }, [t, lang]);

  return (
    <main data-testid="landing-page" className="relative min-h-screen bg-[#0B1733] text-white overflow-x-hidden">
      <Header />
      <Hero />
      <Audiences />
      <RequestViewing />
      <Services />
      <Process />
      <Pricing />
      <WhyUs />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
